import styled from 'styled-components';

export const InputWrapper = styled.div`
  margin: 1em 0;
  position: relative;
`;

export const InputTitle = styled.div`
  margin-top: 20px;
  color: #49166d;
  font-size: 1.2rem;
`;

export const FieldWrapper = styled.div`
  margin: ${props => (props.isRsiOptions ? '0 2rem' : '1em 0')};
  padding: ${props => (props.isRsiOptions ? '1rem' : 0)};
`;

export const Button = styled.button`
  margin: 0.5em 0;
  border: 0;
`;

export const ConfirmationContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  border: 1px solid #aaaaaa;
  padding: 1rem;
  background: #f2eff4;
`;

export const ConfirmationMessage = styled.div`
  max-width: 50%;
  margin-top: 1rem;
  font-weight: 700;
`;

export const ErrorMessage = styled.div`
  color: red;
  margin-top: 1rem;
`;

export const FieldLabelWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

export const FieldLabel = styled.p`
  font-size: 14px;
  font-weight: 500;
  padding: 0.5rem 0;
`;

export const ToolTipWrapper = styled.div`
  margin: 0.25rem 0 0 0.25rem;
`;
